module.exports = __webpack_public_path__ + "static/media/Chumbe_Erfolgsstories.ff9e080a.webp";